import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "placement",
      description: "tooltips位置，与popper.js配置一致",
      type: "String",
      available:
        "left, right, top, top-start, top-end, bottom, bottom-start, bottom-end",
      required: "是"
    },
    {
      prop: "size",
      description: "tooltips尺寸",
      type: "String",
      available: "auto, large, small, small-auto",
      default: "small"
    },
    {
      prop: "theme",
      description: "tooltips主题",
      available: "dark, light",
      type: "String",
      default: "dark"
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "reference",
      description: "基准元素"
    },
    {
      name: "tooltips",
      description: "tooltips元素"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
